// extracted by mini-css-extract-plugin
export var actionButton = "_89-0";
export var attachmentLine = "_89-1";
export var fileInput = "_89-2";
export var fileUploadWrapper = "_89-4";
export var footer = "_89-3";
export var modalContent = "_89-5";
export var paperclip = "_89-6";
export var quillEditor = "_89-7";